import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { EAG_Committee } from '../../interfaces/IMeetingsGmeetsColours';

@Injectable({
    providedIn: 'root'
})
export class EDELGATECalendarService {

    public headers: HttpHeaders;

    constructor(
        private http: HttpClient,
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    getAllAgendaItemsAndColors(AG_Committee: string) {
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/integration/public/api/meetings-gmeets-colours/get-all`, {
            headers: this.headers,
            params: { AG_Committee: this.getBody(AG_Committee) }
        });
    }

    getAllMeetingByDate(body) {
        return this.http.post(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/integration/public/api/gmeet/${body}`, {
            isCancelled: { $ne: true },
            removeHiddenMeetings: true
        }, {
            headers: this.headers,
        });
    }
    getBody(body){
        if(body == 'c1'){
            return EAG_Committee.firstCommittee
        }
        if(body == 'c3'){
            return EAG_Committee.thirdCommittee
        }
        if(body == 'c2'){
            return EAG_Committee.secondCommittee
        }
        if(body == 'c4'){
            return EAG_Committee.fourthCommittee
        }
    }
}
